export default {
  /* UI Colors */
  black: '#000000',
  white: '#ffffff',
  blue: '#0A78BF',
  blueGreen: '#1596B4',
  green: '#33AB6F',
  yellowGreen: '#8EA604',
  yellow: '#F0B91E',
  orange: '#F0871E',
  red: '#DF2F26',
  redViolet: '#A5417D',
  violet: '#5B3E97',
  blueViolet: '#322864',

  /* Grays */
  gray0: '#fafafa',
  gray1: '#f5f5f5',
  gray2: '#eeeeee',
  gray3: '#cccccc',
  gray4: '#97979f',
  gray5: '#666666',
  gray6: '#505055',
  gray7: '#333333',

  /* Classroom Colors */
  minervaOrange: '#f45910',
  minervaOrangeDark: '#d14c03',
  minervaOrangeLight: '#ffa378',
  submitBlue: '#125ea2',
  submitBlueDark: '#08487d',
  submitBlueLight: '#0f83e3',

  // third-party colors
  codeMirrorGray: '#999999',
};

function mix(color1, color2, percentage) {
  function hexForInt(int) {
    let hex = Math.round(int).toString(16);
    if (hex.length === 1) hex = `0${hex}`;
    return hex;
  }
  percentage /= 100;
  color1 = color1.substring(1);
  color2 = color2.substring(1);

  color1 = [
    parseInt(color1[0] + color1[1], 16),
    parseInt(color1[2] + color1[3], 16),
    parseInt(color1[4] + color1[5], 16),
  ];
  color2 = [
    parseInt(color2[0] + color2[1], 16),
    parseInt(color2[2] + color2[3], 16),
    parseInt(color2[4] + color2[5], 16),
  ];

  return [
    (1 - percentage) * color1[0] + percentage * color2[0],
    (1 - percentage) * color1[1] + percentage * color2[1],
    (1 - percentage) * color1[2] + percentage * color2[2],
  ].reduce((hex, int) => hex + hexForInt(int), '#');
}

export function shade(color, percentage) {
  return mix(color, '#000000', percentage);
}

export function tint(color, percentage) {
  return mix(color, '#ffffff', percentage);
}
